/**
 * 更新 .text 結構的顯示頁面
 */
export const updateTextDisplay = (contentRef, pageIndex) => {
  if (!contentRef.current) return;

  // 處理所有 .text element 的顯示狀態
  const textElements = contentRef.current.querySelectorAll('.text');
  textElements.forEach((textEl, index) => {
    if (index === pageIndex) {
      textEl.style.visibility = 'visible';
      textEl.style.position = 'relative';
    } else {
      textEl.style.visibility = 'hidden';
      textEl.style.position = 'absolute';
    }
  });

  // 處理所有 .title element 的顯示狀態
  const titleElements = contentRef.current.querySelectorAll('.title');
  titleElements.forEach(titleEl => {
    const shouldShow = pageIndex === 0;
    titleEl.style.visibility = shouldShow ? 'visible' : 'hidden';
    titleEl.style.position = shouldShow ? 'relative' : 'absolute';
  });
  
  // 處理第一個 .text element 前面的 <br> 和 <img> 元素（標題圖片）
  // 以及最後一個 .text element 後面的 <img> 元素（.abreast_subject 後面的圖片）
  if (textElements.length > 0) {
    const firstTextElement = textElements[0];
    const lastTextElement = textElements[textElements.length - 1];
    const lastPageIndex = textElements.length - 1;
    
    // 找到容器中所有的 <br> 和 <img> 元素
    const allBrElements = contentRef.current.querySelectorAll('br');
    const allImgElements = contentRef.current.querySelectorAll('img');
    
    // 收集所有在第一個 .text 之前的 <br> 和 <img> 元素（標題圖片）
    const precedingElements = [];
    
    // 檢查每個 <br> 是否在第一個 .text 之前
    allBrElements.forEach(br => {
      if (br.compareDocumentPosition(firstTextElement) & Node.DOCUMENT_POSITION_FOLLOWING) {
        precedingElements.push(br);
      }
    });
    
    // 檢查每個 <img> 是否在第一個 .text 之前（標題圖片）
    allImgElements.forEach(img => {
      if (img.compareDocumentPosition(firstTextElement) & Node.DOCUMENT_POSITION_FOLLOWING) {
        precedingElements.push(img);
      }
    });
    
    // 收集所有在最後一個 .text 之後的 <img> 元素（.abreast_subject 後面的圖片）
    const followingElements = [];
    allImgElements.forEach(img => {
      // 檢查圖片是否在最後一個 .text 之後
      if (lastTextElement.compareDocumentPosition(img) & Node.DOCUMENT_POSITION_FOLLOWING) {
        followingElements.push(img);
      }
    });
    
    // 處理標題圖片：
    // - 如果元素在 .img div 內，固定在第一頁顯示
    // - 如果不在 .img div 內，根據 data-second-page 屬性決定顯示頁面
    precedingElements.forEach(el => {
      // 檢查元素是否在 .img div 內
      const isInImgDiv = el.closest('.img') !== null;
      const isInImgSizeDiv = el.closest('.imgSize') !== null;
      
      if (isInImgDiv || isInImgSizeDiv) {
        // .img div 內的內容固定在第一頁顯示
        const shouldShow = pageIndex === 0;
        el.style.visibility = shouldShow ? 'visible' : 'hidden';
        el.style.position = shouldShow ? 'relative' : 'absolute';
      } else {
        // 不在 .img div 內的元素，根據 data-second-page 屬性決定
        const isSecondPageImage = el.tagName === 'IMG' && el.getAttribute('data-second-page') === 'true';
        
        if (isSecondPageImage) {
          // 標題圖片在第二頁顯示
          const shouldShow = pageIndex === 1;
          el.style.visibility = shouldShow ? 'visible' : 'hidden';
          el.style.position = shouldShow ? 'relative' : 'absolute';
        } else {
          // 標題圖片在第一頁顯示（或 <br> 元素）
          const shouldShow = pageIndex === 0;
          el.style.visibility = shouldShow ? 'visible' : 'hidden';
          el.style.position = shouldShow ? 'relative' : 'absolute';
        }
      }
    });

    // 處理最後一頁的圖片：只有在最後一頁時才顯示
    const shouldShowFollowing = pageIndex === lastPageIndex;
    followingElements.forEach(el => {
      if (shouldShowFollowing) {
        el.style.visibility = 'visible';
        el.style.position = 'relative';
      } else {
        el.style.visibility = 'hidden';
        el.style.position = 'absolute';
      }
    });
    
    // 處理獨立頁面的圖片：每個非標題圖片獨立一頁顯示
    allImgElements.forEach(img => {
      const isStandalonePage = img.getAttribute('data-standalone-page') === 'true';
      
      if (isStandalonePage) {
        // 獲取圖片應該顯示的頁面索引
        const pageIndexAttr = img.getAttribute('data-page-index');
        const targetPageIndex = pageIndexAttr ? parseInt(pageIndexAttr, 10) : -1;
        
        // 只在對應的頁面顯示
        const shouldShow = pageIndex === targetPageIndex;
        img.style.visibility = shouldShow ? 'visible' : 'hidden';
        img.style.position = shouldShow ? 'relative' : 'absolute';
      }
    });
    
    // 處理內容圖片：根據標記決定在第二頁顯示
    // 內容圖片必須在第二頁顯示，第一頁隱藏
    allImgElements.forEach(img => {
      const isContentImage = img.getAttribute('data-content-image') === 'true';
      
      if (isContentImage) {
        // 確認不是標題圖片（不在 precedingElements 中）
        const isNotPrecedingImage = !precedingElements.includes(img);
        // 確認不是最後一頁的圖片（不在 followingElements 中）
        const isNotFollowingImage = !followingElements.includes(img);
        
        if (isNotPrecedingImage && isNotFollowingImage) {
          // 內容圖片只在第二頁顯示
          const shouldShow = pageIndex === 1;
          img.style.visibility = shouldShow ? 'visible' : 'hidden';
          img.style.position = shouldShow ? 'relative' : 'absolute';
        }
      }
    });
  }
};

